import { Controller } from "@hotwired/stimulus"
import { Subscriptions } from "@rails/actioncable";
import Rails from "@rails/ujs";
import Cookies from "js-cookie"
import consumer from "channels/consumer";
import {isMobile} from "../../utility_functions";

export default class extends Controller {
  static targets = [
    'container'
  ]

  static values = {
    id: Number
  }

  connect() {
    console.log("🟢 STIMULUS CONTROLLER OPERATIONAL: sidebar!")
    //this.backToDefault()
    if (isMobile()) {
      document.addEventListener('sidebar:collapse', this.collapse.bind(this));
      const sidebar = $(".writer__ai-sidebar.active");
      sidebar.removeClass('active')
      const activeLink = $(".fab__container .nav-link.active")
      activeLink.removeClass('active')
      console.log("removed class here!")
    }
  }

  expand(){
    console.log("🟢 STIMULUS METHOD RUNS: sidebar#expand()!");

    // UPDATE COOKIE & STATE
    $(this.containerTarget).show();
    $('.editor__container').removeClass('expanded');
    Cookies.set('viewSidebar', true);
    $('.sidebarState').data("state", true);
    $('.sidebarState').children('.dynamic-check-holder').show();
    this.backToDefault();

    if (isMobile()) {
      const sidebar = $(".writer__ai-sidebar");
      if (!(sidebar.hasClass('active'))) {
        sidebar.addClass('active')
      }
    }
    // TO TRIGGER INPUT RESIZE
    $('textarea#title').trigger("click");
    window.dispatchEvent(new Event('resize'));
  }

  collapse(){
    console.log("🟢 STIMULUS METHOD RUNS: sidebar--research#collapse()!")
    if (!isMobile()) {
      $(this.containerTarget).hide();
    }

    // CHANGE COOKIES & STATE
    Cookies.set('viewSidebar', false);
    $('.editor__container').addClass('expanded');
    $('.writer__ai-sidebar .nav-item').removeClass('active');
    $('.sidebarState').data("state", false);
    $('.sidebarState').children('.dynamic-check-holder').hide();

    if (isMobile()) {
      const sidebar = $(".writer__ai-sidebar");
      if ((sidebar.hasClass('active'))) {
        sidebar.removeClass('active')
      }
      const fabMenu = $(".fab__container.expanded")
      fabMenu.removeClass('expanded')
      const activeLink = $(".fab__container .nav-link.active")
      activeLink.removeClass('active')
    }

    // TO TRIGGER INPUT RESIZE
    $('textarea#title').trigger("click");
    window.dispatchEvent(new Event('resize'));
  }

  collapseMobile() {
    if (isMobile()) {
      this.collapse()
    }
  }

  backToDefault(){
    console.log("🟢 STIMULUS METHOD RUNS: sidebar#backToDefault()!");

    if ($('.dropdown-menu.comments').hasClass('show')) {
    } else if (isMobile()) {
      $(".writer__ai-sidebar").addClass('active');
    }

    // BACK TO DEFAULT UI
    $(this.containerTarget).html(`<div class="sideBar__Research" data-controller="sidebar--research">
        <div class="sideBar__comment-header sideBar__sidebarHeader">
          <h3>
            <div class="sideBar__icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M9.97308 18H14.0269C14.1589 16.7984 14.7721 15.8065 15.7676 14.7226C15.8797 14.6006 16.5988 13.8564 16.6841 13.7501C17.5318 12.6931 18 11.385 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 11.3843 6.46774 12.6917 7.31462 13.7484C7.40004 13.855 8.12081 14.6012 8.23154 14.7218C9.22766 15.8064 9.84103 16.7984 9.97308 18ZM14 20H10V21H14V20ZM5.75395 14.9992C4.65645 13.6297 4 11.8915 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 11.8925 19.3428 13.6315 18.2443 15.0014C17.624 15.7748 16 17 16 18.5V21C16 22.1046 15.1046 23 14 23H10C8.89543 23 8 22.1046 8 21V18.5C8 17 6.37458 15.7736 5.75395 14.9992ZM13 10.0048H15.5L11 16.0048V12.0048H8.5L13 6V10.0048Z"></path></svg>
            </div>
            Research
          </h3>
          <div class="sideBar__comment-actions">
            <a href="https://learn.reword.com/researching-your-topic" target="_blank" 
              data-bs-custom-class="custom-tooltip-commentResolved" 
              data-bs-toggle="tooltip" data-bs-placement="left" 
              aria-expanded="false" aria-label="Learn more"
              title="Learn more">
              <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM13 13.3551V14H11V12.5C11 11.9477 11.4477 11.5 12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.2723 8.5 10.6656 9.01823 10.5288 9.70577L8.56731 9.31346C8.88637 7.70919 10.302 6.5 12 6.5C13.933 6.5 15.5 8.067 15.5 10C15.5 11.5855 14.4457 12.9248 13 13.3551Z"></path></svg>
            </a>
            <button class="closeSidebar__mobile" data-action="click->sidebar#collapse">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>
          </div>
        </div>
        <form data-action="submit->sidebar--research#askQuestion" action="" accept-charset="UTF-8" method="post"><button class="sidebar__mobile-close">Back</button><input type="hidden" autocomplete="off" /><div class="form__group" id="askQuestionForm"><input class="form-control" data-sidebar--research-target="questionInput" placeholder="Ask any question" type="text" name="question[input]" id="question_input" autocomplete="off" /><button class="btn-transparent" type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right-circle"><circle cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8"></polyline><line x1="8" y1="12" x2="16" y2="12"></line></svg></button></div></form><button class="btn btn-outline-light" data-controller="prompt" data-action="click->sidebar--research#prompt" data-prompt="What subheadings matter to my readers?" data-method="core_subheadings" data-tag-type="h2" data-load-more="false"> What subheadings matter to my readers? </button><button class="btn btn-outline-light" data-controller="prompt" data-action="click->sidebar--research#prompt" data-prompt="What facts should my readers know?" data-method="facts" data-tag-type="a" data-load-more="false"> What facts should my readers know? </button><button class="btn btn-outline-light" data-controller="prompt" data-action="click->sidebar--research#prompt" data-prompt="What statistics could be relevant?" data-method="statistics" data-tag-type="a" data-load-more="false"> What statistics could be relevant? </button><button class="btn btn-outline-light" data-controller="prompt" data-action="click->sidebar--research#prompt" data-prompt="What quotes could I reference?" data-method="expert_quotes" data-tag-type="blockquote" data-load-more="false"> What quotes could I reference? </button><button class="btn btn-outline-light" data-controller="prompt" data-action="click->sidebar--research#prompt" data-prompt="What questions do my readers have?" data-method="reader_questions" data-tag-type="h2" data-load-more="false"> What questions do my readers have? </button><button class="btn btn-outline-light" data-controller="prompt" data-action="click->sidebar--research#prompt" data-prompt="What other titles could work for this article?" data-method="title_variants" data-tag-type="title" data-load-more="false"> What other titles could work for this article? </button><div class="questions__section" data-sidebar--research-target="questionsSection">  <div class="skel-loader"><div class="skel-row"><div class="skel-col w-100 h-50 mb-10"></div></div><div class="skel-row"><div class="skel-col w-100 h-50 mb-10"></div></div><div class="skel-row"><div class="skel-col w-100 h-50 mb-10"></div></div><div class="skel-row"><div class="skel-col w-100 h-50 mb-10"></div></div><div class="skel-row"><div class="skel-col w-100 h-50 mb-10"></div></div><div class="skel-row"><div class="skel-col w-100 h-50 mb-10"></div></div></div></div></div>`);

    // SET SIDEBAR STATE
    // SHOULD HANDLE THIS BETTER
    $('#sidebar__container').data("sidebar-state", "default");
    $('.navSidebar .nav-link').removeClass("active");
    if (!isMobile()) {
      $('.nav-link#research').addClass("active");
    }
  }

  request(url){
    // MAKE PARTIAL HTML REQUEST
    fetch(url, {
      headers: { accept: 'application/json' }})
    .then( data => {
      return data.json();
    }).then( payload => {
      // this is updating UI...
      $(this.containerTarget).html(payload.html);
    });
  }

  disconnect() {
    if (isMobile()) {
      document.removeEventListener('sidebar:collapse', this.collapse.bind(this));
    }
  }
}